<template>
  <div class="detail_cont">
    <h2><img src="@/assets/img/present_detail.png" alt="景品の詳細情報"></h2>
    <div class="present_detail wrapper">
      <div>
        <h3>
          <img class="pc" src="@/assets/img/pc/present_5w.png" alt="オリジナルワイヤレス充電器(3.5W)">
          <img class="sp" src="@/assets/img/sp/present_5w.png" alt="オリジナルワイヤレス充電器(3.5W)">
        </h3>
        <p class="lead"><span class="l">当選人数：20名様</span><br>サトちゃんとサトコちゃんをデザインした<br class="sp">オリジナルの景品です。</p><!-- /.lead -->
        <!-- /.lead -->
        <p class="spec">
            サイズ：約100×7mm<br>材質：ABS,PC,他
        </p>
        <!-- /.spec -->
        <ul class="att">
          <li>※Qi（無線充電規格）対応機種のスマートフォンに充電可能です。</li>
          <li>※スマートフォンカバーの種類によって反応しないことがあります。熱を持つこともございますので、その際はカバーを外して使用してください。</li>
        </ul>
      </div>
      <div>
        <h3>
          <img class="pc" src="@/assets/img/pc/present_bank.png" alt="オリジナルコインバンク（サトちゃん・サトコちゃんセット）">
          <img class="sp" src="@/assets/img/sp/present_bank.png" alt="オリジナルコインバンク（サトちゃん・サトコちゃんセット）">
        </h3>
        <p class="lead"><span class="l">当選人数：30名様</span><br>
            MLB球団のユニフォームを着たサトちゃん・サトコちゃんの
            コインバンクです。(全６種類：シアトル・マリナーズ、ニューヨーク・ヤンキース、シカゴ・カブス、ミネソタ・ツインズ、ロサンゼルス・エンゼルス、ロサンゼルス・ドジャース)
            <br>
            <span class="gr">※全６種類の中から１種類をランダムで発送いたします。<br>球団はお選びいただけませんので予めご了承ください。</span><!-- /.gr -->
        </p><!-- /.lead -->
        <!-- /.lead -->
      </div>
    </div>
    <!-- /.present_detail -->
  </div>
</template>

<script>
export default {
  name: 'Detail'
}
</script>
